<template>
  <v-dialog
    v-model="modalData.isOpen"
    persistent
    max-width="460"
    class="transaction-confirm-dialog"
  >
    <TradeTransactionConfirm
      v-if="modalData.transactionType === TRANSACTION_TYPES.TRADE"
    />
    <DefaultTransactionConfirm v-else />
  </v-dialog>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { TRANSACTION_TYPES } from "@/utils/constants";
import { useTransactionConfirmModal } from "@/stores/transactionConfirmModal";

import DefaultTransactionConfirm from "./TransactionConfirmContent/DefaultTransactionConfirm.vue";
import TradeTransactionConfirm from "./TransactionConfirmContent/TradeTransactionConfirm.vue";

const { modalData } = storeToRefs(useTransactionConfirmModal());
</script>
